<app-header></app-header>

<div class="page-title-area page-title-style-two item-rights">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Formular de evaluare a satisfactiei pacientului</li>
            </ul>
            <h2>Formular de evaluare a satisfactiei pacientului</h2>
        </div>
    </div>
</div>

<div class="about-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h3>Formular de evaluare a satisfactiei pacientului</h3>
                <p>
                    Stimati pacienti, </p>
                <p>In conformitate cu politica in
                    domeniul calitatii a Centrului Medical de Diagnostic, Tratament Ambulatoriu si Medicina preventiva
                    Bucuresti, imbunatatirea calitatii serviciilor oferite dumneavoastra reprezinta o prioritate
                    absoluta. Organizatia noastra doreste sa satisfaca pe deplin solicitarile si asteptarile
                    dumneavoastra. Va rugam sa ne acordati putin din timpul dumneavoastra si sa completati acest
                    formular. </p>
                <p>Va multumim!
                </p>

                <div class="m-b" >
                    <h4 class="m-b-sm">1. Cum ati aflat de  CMDTAMP? <span class="text-danger">*</span></h4>
                    <div class="checkbox checkbox-info display-block no-float m-b-sm">
                        <input  name="sursa"
                               type="checkbox" id="chk4" [(ngModel)]="test.answer1_a" [value]="'Medic specialist'"
                               [ngModelOptions]="{standalone: true}">
                        <label for="chk4">
                            Medic specialist
                        </label>
                    </div>
                    <div class="checkbox checkbox-info display-block no-float m-b-sm">
                        <input name="sursa"
                               type="checkbox" id="chk5"  [(ngModel)]="test.answer1_b" [value]="'Medic de familie'"
                               [ngModelOptions]="{standalone: true}">
                        <label for="chk5">
                            Medic de familie
                        </label>
                    </div>
                    <div class="checkbox checkbox-info display-block no-float m-b-sm">
                        <input  name="sursa"
                               type="checkbox"
                               id="chk6"  [(ngModel)]="test.answer1_c" [value]="'Cunostinte'"
                               [ngModelOptions]="{standalone: true}">
                        <label for="chk6">
                            Cunostinte
                        </label>
                    </div>
                    <div class="checkbox checkbox-info display-block no-float m-b-sm">
                        <input name="sursa"
                               type="checkbox"
                               id="chk8"  [(ngModel)]="test.answer1_d" [value]="'Internet'"
                               [ngModelOptions]="{standalone: true}">
                        <label for="chk8">
                            Internet
                        </label>
                    </div>
                    <div class="checkbox checkbox-info display-block no-float m-b-sm">
                        <input  name="sursa"
                               type="checkbox"
                               id="chk10"  [(ngModel)]="test.answer1_e" [value]="'Alte surse'"
                               [ngModelOptions]="{standalone: true}">
                        <label for="chk10">
                            Alte surse
                        </label>
                    </div>
                </div>
                <div class="m-b" >
                    <h4 class="m-b-sm">2. Cat de usor ati intrat in contact cu noi? <span
                                class="text-danger">*</span></h4>
                    <div class="radio radio-info">
                        <input name="usurinta" type="radio" id="chk11"  [(ngModel)]="form.answer2" [value]="' Foarte usor'"
                        [ngModelOptions]="{standalone: true}">
                        <label for="chk11">
                            Foarte usor
                        </label>
                    </div>
                    <div class="radio radio-info">
                        <input  name="usurinta" type="radio" id="chk12" [(ngModel)]="form.answer2" [value]="'Usor'"
                        [ngModelOptions]="{standalone: true}">
                        <label for="chk12">
                            Usor
                        </label>
                    </div>

                    <div class="radio radio-info">
                        <input name="usurinta" type="radio" id="chk13" [(ngModel)]="form.answer2" [value]="'Greu'"
                        [ngModelOptions]="{standalone: true}">
                        <label for="chk13">
                            Greu
                        </label>
                    </div>

                    <div class="radio radio-info">
                        <input  name="usurinta" type="radio" id="chk14" [(ngModel)]="form.answer2" [value]="'Foarte greu'"
                        [ngModelOptions]="{standalone: true}">
                        <label for="chk14">
                            Foarte greu
                        </label>
                    </div>
                </div>
                <div class="alert alert-info m-b">Pe o de la 1 la 10, unde 1 inseamna foarte nemultumit si 10 inseamna
                    foarte multumit, acordati note la intrebarile noastre.
                </div>
                <div class="m-b">
                    <h4 class="m-b-sm">3. Cat de multumit sunteti de comunicarea dintre noi si dumneavoastra? <span
                                class="text-danger">*</span></h4>
                    <div class="rating-options">
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt3-1">1</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt3" name="pt3" type="radio" id="pt3-1" value="1" [(ngModel)]="form.answer3" [value]="'1'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt3-2">2</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt3" name="pt3" type="radio" id="pt3-2" value="2" [(ngModel)]="form.answer3" [value]="'2'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt3-3">3</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt3" name="pt3" type="radio" id="pt3-3" value="3" [(ngModel)]="form.answer3" [value]="'3'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt3-4">4</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt3" name="pt3" type="radio" id="pt3-4" value="4" [(ngModel)]="form.answer3" [value]="'4'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt3-5">5</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt3" name="pt3" type="radio" id="pt3-5" value="5" [(ngModel)]="form.answer3" [value]="'5'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt3-6">6</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt3" name="pt3" type="radio" id="pt3-6" value="6" [(ngModel)]="form.answer3" [value]="'6'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt3-7">7</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt3" name="pt3" type="radio" id="pt3-7" value="7" [(ngModel)]="form.answer3" [value]="'7'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt3-8">8</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt3" name="pt3" type="radio" id="pt3-8" value="8" [(ngModel)]="form.answer3" [value]="'8'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt3-9">9</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt3" name="pt3" type="radio" id="pt3-9" value="9" [(ngModel)]="form.answer3" [value]="'9'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt3-10">10</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt3" name="pt3" type="radio" id="pt3-10" value="10" [(ngModel)]="form.answer3" [value]="'1'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="m-b">
                    <h4 class="m-b-sm">4. Cat de multumit sunteti de calitatea serviciilor oferite de noi? <span
                                class="text-danger">*</span></h4>
                    <div class="rating-options">
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt4-1">1</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt4" name="pt4" type="radio" id="pt4-1" value="1" [(ngModel)]="form.answer4" [value]="'1'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt4-2">2</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt4" name="pt4" type="radio" id="pt4-2" value="2" [(ngModel)]="form.answer4" [value]="'2'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt4-3">3</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt4" name="pt4" type="radio" id="pt4-3" value="3" [(ngModel)]="form.answer4" [value]="'3'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt4-4">4</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt4" name="pt4" type="radio" id="pt4-4" value="4" [(ngModel)]="form.answer4" [value]="'4'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt4-5">5</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt4" name="pt4" type="radio" id="pt4-5" value="5" [(ngModel)]="form.answer4" [value]="'5'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt4-6">6</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt4" name="pt4" type="radio" id="pt4-6" value="6" [(ngModel)]="form.answer4" [value]="'6'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt4-7">7</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt4" name="pt4" type="radio" id="pt4-7" value="7" [(ngModel)]="form.answer4" [value]="'7'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt4-8">8</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt4" name="pt4" type="radio" id="pt4-8" value="8" [(ngModel)]="form.answer4" [value]="'8'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt4-9">9</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt4" name="pt4" type="radio" id="pt4-9" value="9" [(ngModel)]="form.answer4" [value]="'9'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt4-10">10</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt4" name="pt4" type="radio" id="pt4-10" value="10" [(ngModel)]="form.answer4" [value]="'10'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="m-b">
                    <h4 class="m-b-sm">5. Cat de multumit sunteti de pretul serviciilor noastre? <span
                                class="text-danger">*</span></h4>
                    <div class="rating-options">
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt5-1">1</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt5" name="pt5" type="radio" id="pt5-1" value="1" [(ngModel)]="form.answer5" [value]="'1'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt5-2">2</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt5" name="pt5" type="radio" id="pt5-2" value="2" [(ngModel)]="form.answer5" [value]="'2'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt5-3">3</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt5" name="pt5" type="radio" id="pt5-3" value="3" [(ngModel)]="form.answer5" [value]="'3'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt5-4">4</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt5" name="pt5" type="radio" id="pt5-4" value="4" [(ngModel)]="form.answer5" [value]="'4'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt5-5">5</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt5" name="pt5" type="radio" id="pt5-5" value="5" [(ngModel)]="form.answer5" [value]="'5'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt5-6">6</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt5" name="pt5" type="radio" id="pt5-6" value="6" [(ngModel)]="form.answer5" [value]="'6'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt5-7">7</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt5" name="pt5" type="radio" id="pt5-7" value="7" [(ngModel)]="form.answer5" [value]="'7'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt5-8">8</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt5" name="pt5" type="radio" id="pt5-8" value="8" [(ngModel)]="form.answer5" [value]="'8'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt5-9">9</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt5" name="pt5" type="radio" id="pt5-9" value="9" [(ngModel)]="form.answer5" [value]="'9'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt5-10">10</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt5" name="pt5" type="radio" id="pt5-10" value="10" [(ngModel)]="form.answer5" [value]="'10'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="m-b">
                    <h4 class="m-b-sm">6. Cat de multumit sunteti de comunicarea cu personalul din receptia noastra?
                        <span
                                class="text-danger">*</span></h4>
                    <div class="rating-options">
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt6-1">1</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt6" name="pt6" type="radio" id="pt6-1" value="1" [(ngModel)]="form.answer6" [value]="'1'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt6-2">2</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt6" name="pt6" type="radio" id="pt6-2" value="2" [(ngModel)]="form.answer6" [value]="'2'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt6-3">3</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt6" name="pt6" type="radio" id="pt6-3" value="3" [(ngModel)]="form.answer6" [value]="'3'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt6-4">4</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt6" name="pt6" type="radio" id="pt6-4" value="4" [(ngModel)]="form.answer6" [value]="'4'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt6-5">5</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt6" name="pt6" type="radio" id="pt6-5" value="5" [(ngModel)]="form.answer6" [value]="'5'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt6-6">6</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt6" name="pt6" type="radio" id="pt6-6" value="6" [(ngModel)]="form.answer6" [value]="'6'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt6-7">7</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt6" name="pt6" type="radio" id="pt6-7" value="7" [(ngModel)]="form.answer6" [value]="'7'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt6-8">8</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt6" name="pt6" type="radio" id="pt6-8" value="8" [(ngModel)]="form.answer6" [value]="'8'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt6-9">9</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt6" name="pt6" type="radio" id="pt6-9" value="9" [(ngModel)]="form.answer6" [value]="'9'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt6-10">10</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt6" name="pt6" type="radio" id="pt6-10" value="10" [(ngModel)]="form.answer6" [value]="'10'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="m-b">
                    <h4 class="m-b-sm">7. Cat de multumit sunteti de serviciile oferite de catre asistentii nostri?
                        <span
                                class="text-danger">*</span></h4>
                    <div class="rating-options">
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt7-1">1</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt7" name="pt7" type="radio" id="pt7-1" value="1" [(ngModel)]="form.answer7" [value]="'1'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt7-2">2</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt7" name="pt7" type="radio" id="pt7-2" value="2" [(ngModel)]="form.answer7" [value]="'2'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt7-3">3</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt7" name="pt7" type="radio" id="pt7-3" value="3" [(ngModel)]="form.answer7" [value]="'3'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt7-4">4</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt7" name="pt7" type="radio" id="pt7-4" value="4" [(ngModel)]="form.answer7" [value]="'4'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt7-5">5</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt7" name="pt7" type="radio" id="pt7-5" value="5" [(ngModel)]="form.answer7" [value]="'5'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt7-6">6</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt7" name="pt7" type="radio" id="pt7-6" value="6" [(ngModel)]="form.answer7" [value]="'6'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt7-7">7</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt7" name="pt7" type="radio" id="pt7-7" value="7" [(ngModel)]="form.answer7" [value]="'7'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt7-8">8</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt7" name="pt7" type="radio" id="pt7-8" value="8" [(ngModel)]="form.answer7" [value]="'8'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt7-9">9</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt7" name="pt7" type="radio" id="pt7-9" value="9" [(ngModel)]="form.answer7" [value]="'9'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt7-10">10</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt7" name="pt7" type="radio" id="pt7-10" value="10" [(ngModel)]="form.answer7" [value]="'10'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="m-b">
                    <h4 class="m-b-sm">8. Cat de multumit sunteti de serviciile oferite de medicii nostri?
                        <span
                                class="text-danger">*</span></h4>
                    <div class="rating-options">
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt8-1">1</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt8" name="pt8" type="radio" id="pt8-1" value="1" [(ngModel)]="form.answer8" [value]="'1'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt8-2">2</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt8" name="pt8" type="radio" id="pt8-2" value="2" [(ngModel)]="form.answer8" [value]="'2'"
                                [ngModelOptions]="{standalone: true}" >
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt8-3">3</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt8" name="pt8" type="radio" id="pt8-3" value="3" [(ngModel)]="form.answer8" [value]="'3'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt8-4">4</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt8" name="pt8" type="radio" id="pt8-4" value="4" [(ngModel)]="form.answer8" [value]="'4'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt8-5">5</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt8" name="pt8" type="radio" id="pt8-5" value="5" [(ngModel)]="form.answer8" [value]="'5'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt8-6">6</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt8" name="pt8" type="radio" id="pt8-6" value="6" [(ngModel)]="form.answer8" [value]="'6'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt8-7">7</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt8" name="pt8" type="radio" id="pt8-7" value="7" [(ngModel)]="form.answer8" [value]="'7'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt8-8">8</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt8" name="pt8" type="radio" id="pt8-8" value="8" [(ngModel)]="form.answer8" [value]="'8'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt8-9">9</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt8" name="pt8" type="radio" id="pt8-9" value="9" [(ngModel)]="form.answer8" [value]="'9'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt8-10">10</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt8" name="pt8" type="radio" id="pt8-10" value="10" [(ngModel)]="form.answer8" [value]="'10'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="m-b">
                    <h4 class="m-b-sm">9. Cat de multumit sunteti sunteti de igiena din locatia noastra si de ambianta clinicii?
                        <span class="text-danger">*</span></h4>
                    <div class="rating-options">
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt9-1">1</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt9" name="pt9" type="radio" id="pt9-1" value="1" [(ngModel)]="form.answer9" [value]="'1'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt9-2">2</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt9" name="pt9" type="radio" id="pt9-2" value="2" [(ngModel)]="form.answer9" [value]="'2'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt9-3">3</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt9" name="pt8" type="radio" id="pt9-3" value="3" [(ngModel)]="form.answer9" [value]="'3'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt9-4">4</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt9" name="pt9" type="radio" id="pt9-4" value="4" [(ngModel)]="form.answer9" [value]="'4'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt9-5">5</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt9" name="pt9" type="radio" id="pt9-5" value="5" [(ngModel)]="form.answer9" [value]="'5'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt9-6">6</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt9" name="pt9" type="radio" id="pt9-6" value="6" [(ngModel)]="form.answer9" [value]="'6'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt9-7">7</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt9" name="pt9" type="radio" id="pt9-7" value="7" [(ngModel)]="form.answer9" [value]="'7'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt9-8">8</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt9" name="pt9" type="radio" id="pt9-8" value="8" [(ngModel)]="form.answer9" [value]="'8'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt9-9">9</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt9" name="pt9" type="radio" id="pt9-9" value="9" [(ngModel)]="form.answer9" [value]="'9'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                        <div class="display-inline-block">
                            <label class="vertical-label" for="pt9-10">10</label>
                            <div class="radio radio-info m-t-none">
                                <input data-ng-model="vm.form.pt9" name="pt9" type="radio" id="pt9-10" value="10" [(ngModel)]="form.answer9" [value]="'10'"
                                [ngModelOptions]="{standalone: true}">
                                <label></label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="m-b">
                    <table class="table table-striped">
                        <tr class="bg-white">
                            <th style="border-top: none; padding-left: 0px;">
                                <div class="m-b-sm m-t-none">34. Avand in vedere prestatia CMDTAMP: <span
                                            class="text-danger">*</span></div>
                            </th>
                            <th style="border-top: none;">DA</th>
                            <th style="border-top: none;">NU</th>
                        </tr>
                        <tr>
                            <td>doriti continuarea colaborarii cu noi?</td>
                            <td>
                                <div class="radio radio-info m-t-none">
                                    <input data-ng-model="vm.form.pt34s1" name="pt34.1" type="radio" id="pt34.1-1"
                                           value="DA" [(ngModel)]="form.answer34a" [value]="'DA'"
                                           [ngModelOptions]="{standalone: true}">
                                    <label for="pt34.1-1"></label>
                                </div>
                            </td>
                            <td>
                                <div class="radio radio-info m-t-none">
                                    <input data-ng-model="vm.form.pt34s1" name="pt34.1" type="radio" id="pt34.1-2"
                                           value="NU" [(ngModel)]="form.answer34a" [value]="'NU'"
                                           [ngModelOptions]="{standalone: true}">
                                    <label for="pt34.1-2"></label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>ne-ati recomanda?</td>
                            <td>
                                <div class="radio radio-info m-t-none">
                                    <input data-ng-model="vm.form.pt34s2" name="pt34.2" type="radio" id="pt34.2-1"
                                           value="DA" [(ngModel)]="form.answer34b" [value]="'DA'"
                                           [ngModelOptions]="{standalone: true}" >
                                    <label for="pt34.2-1"></label>
                                </div>
                            </td>
                            <td>
                                <div class="radio radio-info m-t-none">
                                    <input data-ng-model="vm.form.pt34s2" name="pt34.2" type="radio" id="pt34.2-2"
                                           value="NU" [(ngModel)]="form.answer34b" [value]="'NU'"
                                           [ngModelOptions]="{standalone: true}">
                                    <label for="pt34.2-2"></label>
                                </div>
                            </td>
                        </tr>

                    </table>
                </div>

                <div class="m-b form-group">
                    <label for="pt40" style="font-weight: normal">Observatii si recomandari:</label>
                    <textarea id="pt40" data-ng-model="vm.form.pt40" name="pt40" class="form-control" [(ngModel)]="form.observations"
                    [ngModelOptions]="{standalone: true}"></textarea>
                </div>
                <div class="m-b form-group">
                    <label for="pt40" style="font-weight: normal">Client/Pacient:</label>
                    <input id="pt40" data-ng-model="vm.form.pt40" name="pt40" class="form-control" [(ngModel)]="form.client"
                    [ngModelOptions]="{standalone: true}">
                </div>
                <a  class="default-btn" (click)="sendData()"><i class='bx bx-book-reader icon-arrow before' ></i><span
                    class="label">Trimite</span></a>
            </div>
        </div>
    </div>
</div>
